import * as React from "react";

const textColor = "#96a5ae";

const logoStyle = {
  fill: textColor
};

const logo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="15"
    width="60"
    viewBox="0 0 360 95"
  >
    <path
      style={logoStyle}
      d="M140.36,73.24h-6.14L117,28h8.76l11.88,33,12.23-33h8.59L140.36,73.24Zm58.23-26.93a16.28,16.28,0,0,0-5.26-8.66,13.67,13.67,0,0,0-9-3.07,14.47,14.47,0,0,0-9.28,3.14,16.11,16.11,0,0,0-5.4,8.59Zm-29.16,7.32a15.41,15.41,0,0,0,5.13,9.19,15.11,15.11,0,0,0,17.07,1.58,14.23,14.23,0,0,0,5.28-5.46h9.16a25.76,25.76,0,0,1-8.73,11.51,22,22,0,0,1-13.05,4,23.36,23.36,0,0,1-9.18-1.76,22.72,22.72,0,0,1-7.53-5.31,24.52,24.52,0,0,1-5-7.75,23.72,23.72,0,0,1-1.79-9,24.38,24.38,0,0,1,1.63-8.93,23.79,23.79,0,0,1,4.79-7.56,21.9,21.9,0,0,1,16.86-7.44,22.87,22.87,0,0,1,11.09,2.78,23.65,23.65,0,0,1,8.45,7.75,23.35,23.35,0,0,1,2.92,6.76,34.06,34.06,0,0,1,.94,8.41v1.28ZM214.6,73.24V13.35h8.06V73.24Zm23.9-22.91a15.81,15.81,0,0,0,4.55,11.51,14.93,14.93,0,0,0,11.12,4.65,14.47,14.47,0,0,0,10.59-4.66,15.15,15.15,0,0,0,4.57-10.92,16,16,0,0,0-4.53-11.42A14.46,14.46,0,0,0,254,34.75a15.48,15.48,0,0,0-15.5,15.58Zm30.43,22.91V67.68a21.59,21.59,0,0,1-7,4.92,20.6,20.6,0,0,1-8.21,1.67,22.91,22.91,0,0,1-16.94-6.81,23.22,23.22,0,0,1-6.74-17,24.53,24.53,0,0,1,1.68-9,22.89,22.89,0,0,1,4.82-7.53A22.19,22.19,0,0,1,244,28.56a23.64,23.64,0,0,1,9.24-1.72,21.72,21.72,0,0,1,8.55,1.65,21.27,21.27,0,0,1,7.12,5V28h8.22V73.24Zm25.91,0H286.7V28h7.65v5.23A13.63,13.63,0,0,1,299,28.77a12.66,12.66,0,0,1,6.07-1.51v8.51c-3.65.28-6.26,1.35-7.83,3.23s-2.38,4.9-2.38,9.07V73.24Zm21.92-22.66a15.83,15.83,0,0,0,4.29,11.32,14.15,14.15,0,0,0,10.72,4.52,13.87,13.87,0,0,0,10.54-4.55,16,16,0,0,0,4.25-11.37,15.88,15.88,0,0,0-4.25-11.36,14.77,14.77,0,0,0-21.26.07,15.92,15.92,0,0,0-4.29,11.37Zm-8.44.09a24.59,24.59,0,0,1,1.63-9,22.73,22.73,0,0,1,4.79-7.51,24.37,24.37,0,0,1,7.69-5.63,20.91,20.91,0,0,1,8.89-2,22.86,22.86,0,0,1,16.77,7,24.71,24.71,0,0,1,5.13,7.7A22.7,22.7,0,0,1,355,50.09a25.35,25.35,0,0,1-1.67,9,24.11,24.11,0,0,1-12.41,13.44,22,22,0,0,1-9.15,2,23.14,23.14,0,0,1-9.17-1.78,22.74,22.74,0,0,1-7.54-5.3,24.43,24.43,0,0,1-5-7.75A23.88,23.88,0,0,1,308.32,50.67Z"
    />
    <path
      style={logoStyle}
      d="M55.76,38a9.55,9.55,0,1,1-9.33,9.55A9.45,9.45,0,0,1,55.76,38Z"
    />
    <path
      style={logoStyle}
      d="M48.11,91.65C-5.17,54.54,18,30.44,54.13,29,70.48,28.33,71,1.26,53.48,3.48,36.23,5.69-1,20.25,5.83,46.72,11.05,66.85,35.74,87.25,48.11,91.65Z"
    />
    <path
      style={logoStyle}
      d="M63.42,3.35c53.27,37.11,30.11,61.21-6,62.67-16.35.65-16.85,27.73.64,25.5,17.25-2.21,54.51-16.77,47.65-43.24C100.48,28.15,75.79,7.75,63.42,3.35Z"
    />
  </svg>
);

export default function PoweredBy() {
  return (
    <a
      className="velaro-powered-by"
      href="https://www.velaro.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Powered by Velaro - to velaro.com"
    >
      <div className="velaro-powered-by-text" style={{ color: textColor }}>
        by
      </div>
      <div className="velaro-powered-by-logo">{logo}</div>
    </a>
  );
}
